import {BaseCreateItemStore} from "@leap4/frontend";
import {IAlert} from "@leap4/entities-discrepancy-common";

export class CreateAlertStore extends BaseCreateItemStore<IAlert>{
    entityName: string ="Alert";
}